import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchBillingProfilesForTransactionAccountInPPC } from '../queries/fetch-billing-profiles-for-transaction-account';
import { isEmpty } from 'lodash';

type UseFetchBillingProfilesQueryVariables = {
  invoiceGroupIds?: string[];
  transactionAccountId: string;
  sortOptions?: generatedTypesNew.SortType;
  filterOptions?: generatedTypesNew.Maybe<generatedTypesNew.FilterOption>[] | generatedTypesNew.FilterOption | null;
};

const defaultSearchOptions = {
  first: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
};

export const useFetchBillingProfiles = ({
  invoiceGroupIds,
  transactionAccountId,
  sortOptions,
  filterOptions,
}: UseFetchBillingProfilesQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  const isSkipCall = filterOptions ? false : invoiceGroupIds ? invoiceGroupIds.length === 0 : false;
  return usePersistedCacheQuery<
    generatedTypesNew.FetchBillingProfilesForTransactionAccountInPpcQuery,
    generatedTypesNew.FetchBillingProfilesForTransactionAccountInPpcQueryVariables
  >(fetchBillingProfilesForTransactionAccountInPPC, {
    variables: {
      id: transactionAccountId,
      searchOptions: {
        ...defaultSearchOptions,
        ...(!isEmpty(sortOptions) && { sort: sortOptions }),
      },
      refetchDefaultPaymentMethod: false,
      filterOptions: filterOptions
        ? filterOptions
        : [
            {
              key: 'or',
              value: JSON.stringify(invoiceGroupIds?.map((id) => ({ id }))),
            },
          ],
    },
    displayName: 'fetchBillingProfilesForTransactionAccountInPPC',
    // @ts-ignore
    skip: !transactionAccountId || isSkipCall,
    client: ansClient,
  });
};
